// GA4 Events

// ErrorOccurredHandleError
// Event Name: error_occurred
const ErrorOccurredHandleError = message => {
  const ga4object = {
    'event': 'error_occurred',
    'event_params': {
      'error_field': 'error_occured',
      'error_code': message,
      'error_name': message,
      'error_feature': 'error_occured'
    }
  };
  ExecuteGA4Event(ga4object, true);
}

// convert Class to JSON
const ClassToJson = obj => {
  const jsonString = JSON.stringify(obj);

  return JSON.parse(jsonString)
}

// Objects describing ecommerce analytics is repeated often so creating a class
// The classes 'Item' and 'ItemVerbose' are often used with it
class EcommerceParentObject {
  constructor(obj) {
    const objValue = {
      event: `${obj.event}`,
      event_params: {
        ecommerce: {
          value: `${obj.value}`,
          currency: `${obj.currency}`,
          items: []
        }
      }
    };

    Object.assign(this, objValue);
  }
}

class Item {
  constructor(obj) {
    const itemObject = {
      item_name: `${obj.item_name}`,
      item_id: `${obj.item_id}`,
      item_brand: `${obj.item_brand}`,
      item_category: `${obj.item_category}`,
      item_variant: `${obj.item_variant}`,
      quantity: `${obj.quantity}`,
      price: `${obj.price}`
    };

    Object.assign(this, itemObject);
  }
}

class ItemVerbose extends Item {
  constructor(obj) {
    super(obj);

    this.coupon = `${obj.coupon}`;
    this.discount = `${obj.discount}`;
  }
}

// ExpandContentHandleClick
// Event Name: expand_content
const ExpandContentHandleClick = e => {
  const name = e.target.innerText;
  const ga4Object = {
    'event': 'expand_content',
    'event_params': {
      'content_name': `${name}`
    }
  };
  ExecuteGA4Event(ga4Object);
};

// SelectContentHandleClick
// Event Name: select_content
// Data Attributes:
// data-ga4-content-type: fulfills and 'content_type'
const SelectContentHandleClick = e => {
  const url = `${e.target.hostname}${e.target.pathname}`;
  let contentName = e.target.dataset.ga4ContentName;
  let contentType = e.target.dataset.ga4ContentType;
  if (!contentName) {
    contentName = e.target.dataset.ga4Name;
    contentType = e.target.dataset.ga4EventType;
    if (!contentName) {
      contentName = e.target.innerText;
    }
    if (!contentType) {
      contentType = 'link';
    }
  }
  const ga4Object = {
    'event': 'select_content',
    'event_params': {
      'cta_location': `${window.location.pathname}`,
      'link_url': `${url}`,
      'content_type': `${contentType}`,
      'content_name': `${contentName}`
    }
  };
  ExecuteGA4Event(ga4Object);
};

// NavClickHandleClick
// Event Name: nav_click
// Data Attributes [* - Optional]:
// data-ga4-name*: fulfills 'nav_item'
// data-ga4-nav-type: fulfills 'nav_type'
const NavClickHandleClick = e => {
  const name = e.target.dataset.ga4Name ? e.target.dataset.ga4Name : e.target.innerText;
  const navType = e.target.dataset.ga4NavType;
  const ga4Object = {
    'event': 'nav_click',
    'event_params': {
      'nav_item': `${name}`,
      'nav_type': `${navType}`
    }
  };
  ExecuteGA4Event(ga4Object);
};

// RetailerLinksHandleClick
// Event Name: select_retailer
// Data Attributes:
// data-ga4-retailer: fulfills 'retailer'
const RetailerLinksHandleClick = e => {

  const name = e.target.dataset.ga4Retailer;
  const ga4Object = {
    "event": "select_retailer",
    "event_params": {
      "retailer": `${name}`
    }
  };
  ExecuteGA4Event(ga4Object);
};

// ViewSearchResultsHandleClick
// Event Name: view_search_results
const ViewSearchResultsHandleSubmit = e => {

  const searchTerm = document.getElementById('Search-In-Modal').value;
  const ga4Object = {
    "event": "view_search_results",
    "event_params": {
      "search_term": `${searchTerm}`
    }
  };
  ExecuteGA4Event(ga4Object);
};

// Watch GA4Obj
// Use when you need to watch an object to run a function
// Argument 1: object you want to watch for
// Argument 2: callback function to run
const WatchGA4Obj = (obj, callback, setTimer = 500) => {
  const timer = setInterval(() => {
    if (obj) {
      callback(obj);
      clearInterval(timer);
    }
  }, setTimer);
};

export {
  ClassToJson,
  ErrorOccurredHandleError,
  ExpandContentHandleClick,
  NavClickHandleClick,
  EcommerceParentObject,
  Item,
  ItemVerbose,
  RetailerLinksHandleClick,
  SelectContentHandleClick,
  ViewSearchResultsHandleSubmit,
  WatchGA4Obj
};
